import { useState, useEffect } from 'react'
import { Grid, Marker, Form } from '@design-systems/canvas-ui'
import { isValidEmail } from 'mvscommoncomponents'

const EmailRow = (props) => {
  const [emailList, setEmailList] = useState([])
  const [newEmailEntry, setNewEmailEntry] = useState('')

  useEffect(() => {
    setEmailList(props.emailList)
    if (props.isFocus) {
      focusOnEmailTextbox()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.emailList, props.isFocus])

  useEffect(() => {
    isAllValidEmailDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailList, props.emailList])

  /**
   * Put focus on Email textbox
   */
  const focusOnEmailTextbox = () => {
    document.getElementById(`emailBox-${props.emailRecipientGroup}`)?.focus()
  }

  const renderEmailChipView = (emailList) => {
    let allEmails = emailList?.map((eachEmail, emailIndex) => {
      return (
        <Marker
          key={`chip-${props.emailRecipientGroup}-${emailIndex}`}
          id={`chip-${props.emailRecipientGroup}-${emailIndex}`}
          className={[
            'lcm-email-row__email-marker',
            'hc8-clr-placeholder',
            'hc8-mr-1x',
            'hc8-mb-1x',
            getEmailChipColor(eachEmail),
          ].join(' ')}
          size="sm"
          variant="outlined"
          onRemove={() => {
            let mails = [...emailList]
            mails.splice(emailIndex, 1)
            setEmailList(mails)
            props.updateEmailList(mails, props.emailRecipientGroup)
          }}
        >
          {eachEmail}
        </Marker>
      )
    })
    return (
      <div className="lcm-email-row__chips">
        {allEmails}
        {allEmails?.length > 0 && (
          <label
            data-testid={`remove-all`}
            className="lcm-email-row__remove-all hc8-clr-brand hc8-fs-100"
            onClick={() => setEmailList([])}
          >
            Remove All
          </label>
        )}
      </div>
    )
  }

  /**
   * Is all email details valid (count > 0 & all emails are valid)
   * @returns
   */
  const isAllValidEmailDetails = () => {
    let isSectionValid =
      emailList?.length > 0 &&
      emailList?.filter((e) => !isValidEmail(e)).length === 0
    props.updateIsAllValidEmailDetails(
      isSectionValid,
      props.emailRecipientGroup,
    )
  }

  /**
   * Get email chip colour
   * @param {*} email
   * @returns
   */
  const getEmailChipColor = (email) => {
    return !isValidEmail(email) ? 'email-chip-error' : 'email-chip-normal'
  }

  const emailEnteringOnChange = (event, onMouseLeave) => {
    if (['Enter', 'Tab', ',', ' '].includes(event.key) || onMouseLeave) {
      event.preventDefault()

      let newEmailEntered = event.target.value
      if (newEmailEntered.length > 0) {
        let newEmailList = [...emailList, newEmailEntered]
        setEmailList(newEmailList)
        setNewEmailEntry('')
        props.updateEmailList(newEmailList, props.emailRecipientGroup)
      }
    }
  }

  return (
    <Grid.Container
      key={`email-list-${props.emailRecipientGroup}`}
      id="email-row"
      className="lcm-email-row hc8-ph-6x hc8-pv-2x"
      onClick={() => {
        focusOnEmailTextbox()
      }}
    >
      {props.inputType !== 'ctv' && (
        <Grid.Item
          size={{ xs: 1 }}
          className="lcm-email-row__label-column hc8-pr-none hc8-pb-none"
        >
          <Marker className="lcm-email-row__group-marker hc8-mt-1x">
            {props.emailRecipientGroup}
          </Marker>
        </Grid.Item>
      )}
      <Grid.Item
        size={{ xs: 11 }}
        className="lcm-email-row__field-column hc8-pb-none"
      >
        <div className="email-entry-field-dim lcm-email-row__entry hc8-bg-subdued hc8-pa-2x">
          <div className="lcm-email-row__chip-area">
            {renderEmailChipView(emailList)}
          </div>
          <Form.Field
            type="text"
            className="new-email-box lcm-email-row__input hc8-wth-100"
            size="md"
            id={`emailBox-${props.emailRecipientGroup}`}
            data-testid={`emailBox-${props.emailRecipientGroup}`}
            value={newEmailEntry}
            onChange={(event) => {
              let newEmailFieldEntry = event.target.value
              let emails = []
              newEmailFieldEntry.split(';').forEach((email) =>
                email.split(' ').forEach((email) =>
                  email.split(',').forEach((e) => {
                    let mail = e.trim()
                    if (mail.length > 0) {
                      emails.push(mail)
                    }
                  }),
                ),
              )

              if (emails.length > 1) {
                let newEmails = [...emailList, ...emails]
                setEmailList(newEmails)
                props.updateEmailList(newEmails, props.emailRecipientGroup)
              } else {
                setNewEmailEntry(newEmailFieldEntry)
              }
            }}
            placeholder={'Please enter email(s) separated by comma'}
            onKeyDown={(event) => emailEnteringOnChange(event)}
            onMouseLeave={(event) => emailEnteringOnChange(event, true)}
          />
        </div>
      </Grid.Item>
    </Grid.Container>
  )
}

export default EmailRow
